export default `blog-toc-title = Neste artigo

`;